// extracted by mini-css-extract-plugin
module.exports = {"cardRow":"cardRow--GpNhc","word":"word--mc9mR","pict":"pict--ksJBY"};